module.exports = __webpack_public_path__ + "static/img/robot-title.e9160d96.png";